import * as React from "react";
import "./index.css";

export const LoadingPage = () => {
    return (
        <article className="loadpg">
            <p className="loadpg-text">Loading...</p>
        </article>
    );
};
